import { render, staticRenderFns } from "./CulruralCustomMade.vue?vue&type=template&id=651fd2a2&"
import script from "./CulruralCustomMade.vue?vue&type=script&lang=js&"
export * from "./CulruralCustomMade.vue?vue&type=script&lang=js&"
import style0 from "./CulruralCustomMade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports